import { RenderProgressSuccessResult } from 'js/types';

export const DOWNLOAD_RESET = 'DOWNLOAD_RESET';
export const DOWNLOAD_REQUEST = 'DOWNLOAD_REQUEST';
export const DOWNLOAD_CACHED_PROJECT = 'DOWNLOAD_CACHED_PROJECT';
const FETCH_RENDER_STATUS_FAILED = 'FETCH_RENDER_STATUS_FAILED';
const POLLING_CANCELLED = 'POLLING_CANCELLED';
export const FETCH_RENDER_PROGRESS_SUCCESS = 'FETCH_RENDER_PROGRESS_SUCCESS';
export const ABORT_DOWNLOAD_USER_ACTION = 'ABORT_DOWNLOAD_USER_ACTION';
export const DOWNLOAD_SUCCESS_UPSELL_ACTION = 'DOWNLOAD_SUCCESS_UPSELL_ACTION';

export interface RequestDownloadAction {
  type: typeof DOWNLOAD_REQUEST;
  scribeId: number;
  format: string;
}

export const requestDownload = (scribeId: number, format: string): RequestDownloadAction => ({
  type: DOWNLOAD_REQUEST,
  scribeId,
  format
});

export interface DownloadCachedProjectAction {
  type: typeof DOWNLOAD_CACHED_PROJECT;
  projectId: number;
}

export const downloadCachedProject = (projectId: number): DownloadCachedProjectAction => ({
  type: DOWNLOAD_CACHED_PROJECT,
  projectId
});

export { DOWNLOAD_REQUEST_SUCCESS, downloadRequestSuccess } from './downloadRequestSuccessAction';
export { DOWNLOAD_REQUEST_FAILED, downloadRequestFailed } from './downloadRequestFailedAction';

export const downloadReset = () => ({ type: DOWNLOAD_RESET });

interface FetchRenderStatusFailedAction {
  type: typeof FETCH_RENDER_STATUS_FAILED;
  error: Error;
  shortId: number;
}

export const fetchRenderStatusFailed = (error: Error, shortId: number): FetchRenderStatusFailedAction => ({
  type: FETCH_RENDER_STATUS_FAILED,
  error,
  shortId
});

export { START_RENDER_STATUS_POLLING, startRenderStatusPolling } from './startRenderStatusPollingAction';
export { STOP_RENDER_STATUS_POLLING, stopRenderStatusPolling } from './stopRenderStatusPollingAction';

interface PollingCancelledAction {
  type: typeof POLLING_CANCELLED;
  shortId: number;
}

export const pollingCancelled = (shortId: number): PollingCancelledAction => ({
  type: POLLING_CANCELLED,
  shortId
});

export { RENDER_FAILED, renderFailed } from './renderFailedAction';
export { getVideoDownloadUrlSuccess, GET_VIDEO_DOWNLOAD_URL_SUCCESS } from './getVideoDownloadUrlSuccessAction';
export { GET_VIDEO_DOWNLOAD_URL_FAILED, getVideoDownloadUrlFailed } from './getVideoDownloadUrlFailedAction';

export interface FetchRenderProgressSuccessAction {
  type: typeof FETCH_RENDER_PROGRESS_SUCCESS;
  shortId: number;
  result: RenderProgressSuccessResult;
}

export const fetchRenderProgressSuccess = (
  shortId: number,
  result: RenderProgressSuccessResult
): FetchRenderProgressSuccessAction => ({
  type: FETCH_RENDER_PROGRESS_SUCCESS,
  shortId,
  result
});

export { ABORT_DOWNLOAD, abortDownload } from './abortDownloadAction';

export const abortDownloadUserAction = () => ({
  type: ABORT_DOWNLOAD_USER_ACTION
});

export const downloadSuccessUpsellAction = () => ({
  type: DOWNLOAD_SUCCESS_UPSELL_ACTION
});
